import { render, staticRenderFns } from "./Certifications.vue?vue&type=template&id=15c6f0e7&scoped=true"
import script from "./Certifications.vue?vue&type=script&lang=js"
export * from "./Certifications.vue?vue&type=script&lang=js"
import style0 from "./Certifications.vue?vue&type=style&index=0&id=15c6f0e7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c6f0e7",
  null
  
)

export default component.exports